import React, { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import {
  BLUEARROW_ICON,
  GREYARROW_ICON,
  LOGO_COLLAPSED_IMG,
  LOGO_IMG,
} from "../../../utills/image-constant";
import { useDispatch, useSelector } from "react-redux";
import { menuData } from "./adminMenuData";
import { ROUTES } from "../../routes/url-constant";
import { adminLogout, getRoleById } from "../../../services/api-services";
import { setAdminRoleReducer } from "../../hooks/redux/slice/admin-role";
import LogoutModel from "./LogoutModel";
import {
  setActiveItem,
  setActiveSubItem,
} from "../../hooks/redux/slice/active-route";
import { toastEmitter } from "../../../utills/utilities";
import { clearAccessTokenReducer } from "../../hooks/redux/slice/access-token";
import { clearLoggedUserReducer } from "../../hooks/redux/slice/logged-user";

const LeftBar = ({ isVisible }) => {
  const { value } = useSelector((state) => state?.loggedUser);
  const Token = useSelector((state) => state?.accessToken?.value);
  const { activeItem, activeSubItem } = useSelector(
    (state) => state.activeRoute
  ); // Access active route state from Redux
  const [openSubmenu, setOpenSubmenu] = useState(null);
  const [menuListData, setMenuListData] = useState([]);
  const navigation = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const logoutModalRef = useRef();


  const GetAllPermissionData = async () => {
    try {
      const response = await getRoleById(value?.roleResponsePayload?.id);
      if (response?.status === 200) {
        setMenuListData(response?.data?.roleModuleMappingResponseList);
        dispatch(
          setAdminRoleReducer(response?.data?.roleModuleMappingResponseList)
        )
      }
    } catch (err) {
      console.error("Error fetching role data", err);
    }
  };

  const navigate = useNavigate();

  useEffect(() => {
    if (!value?.roleResponsePayload?.id || !Token) return;
    GetAllPermissionData();
  }, [value, Token]);

  const handleAdminLogout = async () => {
    try {
      const response = await adminLogout(Token);
      if (response?.status === 200) {
        toastEmitter("success", "Admin Logout Successfully");
        dispatch(clearAccessTokenReducer());
        dispatch(clearLoggedUserReducer());
        localStorage.removeItem("RoleValue")
        localStorage.removeItem("DimesionMenegmentModalId")
        localStorage.removeItem("sub-DimesionMenegmentModalId");
        localStorage.removeItem("sub-DimesionMenegmentDimesionId");
        localStorage.removeItem("criteriaMenegmentModalId");
        localStorage.removeItem("criteriaMenegmentDimesionId");
        localStorage.removeItem("criteriaMenegmentSubDimesionId");
        localStorage.removeItem("ViewAssesmentCompanyId")
        localStorage.removeItem("OnsiteCompanyId")
        navigate(ROUTES.ADMINLOGINPAGE);
      }
    } catch (err) {
      console.error("Error fetching role data", err);
    }
  };

  useEffect(() => {
    const currentPath = location.pathname;
    const dashboardItem = menuData.find((item) => item.name === "Dashboard");
    if (currentPath === ROUTES.DASHBOARD) {
      dispatch(setActiveItem(dashboardItem.id));
    } else {
      const matchedItem = menuData?.find(
        (item) =>
          item?.url === currentPath ||
          item?.subItems?.some((sub) => sub?.url === currentPath)
      );

      if (matchedItem) {
        dispatch(setActiveItem(matchedItem?.id));
        if (matchedItem?.subItems) {
          const matchedSubItem = matchedItem?.subItems?.find(
            (sub) => sub?.url === currentPath
          );
          if (matchedSubItem) {
            dispatch(setActiveSubItem(matchedSubItem?.id));
            setOpenSubmenu(matchedItem?.id);
          }
        }
      }
    }
  }, [location.pathname, dispatch]);

  const handleToggleSubmenu = (id) => {
    setOpenSubmenu((prev) => (prev === id ? null : id));
  };
  const handleSetActive = (item) => {
    if (item?.subItems) {
      // Open the submenu if it is not already open
      handleToggleSubmenu(item.id);
      dispatch(setActiveItem(item.id));

      // Set the first sub-item as active by default
      const firstSubItem = item.subItems[0];
      dispatch(setActiveSubItem(firstSubItem.id));
      // Navigate to the first sub-item's route
      navigation(firstSubItem.url);
    } else {
      dispatch(setActiveItem(item.id));
      dispatch(setActiveSubItem(null));
      setOpenSubmenu(null);
    }
  };

  const handleSetActiveSubItem = (subitem) => {
    dispatch(setActiveSubItem(subitem.id));
  };

  const filteredMenuData = menuData?.filter(
    (item) =>
      // item.name === "Dashboard" || // Always show Dashboard
      menuListData?.some(
        (role) => role.moduleName === item.name && role.viewAction == 1
      ) ||
      item.name === "Logout" ||
      item.name === "Settings"
  );;

  const handleLogout = () => {
    logoutModalRef.current.click();
  };

  return (
    <>
      <div
        className={`sidenav ps-0 d-none d-md-block  shadow ${isVisible ? 'visible' : 'hidden'}`}
      >
        <div className="d-flex flex-column align-items-center align-items-sm-start ps-0 px-1 min-vh-100">
          <div className="d-none d-md-flex m-auto align-items-center mb-3 mt-4 text-white text-decoration-none">
            <img
              src={isVisible ? LOGO_IMG : LOGO_IMG}
              alt="Logo"
              className={`logo ${isVisible ? "full-logo" : "collapsed-logo"}`}
            />
          </div>
          <ul
            className="nav nav-pills flex-column mb-sm-auto mb-0 align-items-center align-items-sm-start leftbarul"
            id="menu"
          >
            {filteredMenuData?.map((item) => {
              return (
                <li
                  className={`nav-item list-group-item w-100 ${activeItem === item.id ? "active" : ""
                    }  ${item.code === "Logout" ? "logoutTextRed" : ""}`}
                  key={item?.id}
                >
                  <div
                    onClick={() =>
                      item.name === "Logout"
                        ? handleLogout()
                        : handleSetActive(item)
                    }
                    className="text-decoration-none "
                    style={{ cursor: item?.subItems ? "pointer" : "default" }}
                  >
                    <Link to={item?.url} className="nav-link px-0 ps-2 pb-0">
                      <div className="sidebariconsec">
                        <img src={item?.icon} alt="" className="sidebaricon" />
                      </div>
                      <span className="ms-1 d-none d-sm-inline-block mainuitemstext">
                        {item?.name}
                      </span>
                      {item?.subItems && (
                        <span className="mainuitems">
                          <img
                            src={
                              openSubmenu === item.id
                                ? BLUEARROW_ICON
                                : GREYARROW_ICON
                            }
                            alt=""
                            className="mainuitemsimg ms-2"
                          />
                        </span>
                      )}
                    </Link>
                  </div>
                  {item?.subItems && (
                    <ul
                      className={`collapse nav flex-column flashitems ${openSubmenu === item.id ? "show" : ""
                        }`}
                      id={`submenu-${item.id}`}
                    >
                      {item.subItems.map((subitem) => (
                        <li
                          className={`nav-item ${activeSubItem === subitem.id ? "active" : ""
                            }`}
                          key={subitem.id}
                        >
                          <Link
                            to={subitem?.url}
                            className="text-decoration-none"
                            onClick={() => handleSetActiveSubItem(subitem)}
                          >
                            <span className="submenuitems">
                              {subitem?.name}
                            </span>
                          </Link>
                        </li>
                      ))}
                    </ul>
                  )}
                </li>
              );
            })}
          </ul>
        </div>
      </div>
      <LogoutModel
        title="Are you sure you want to logout!"
        LogoutModel={logoutModalRef}
        handleAdminLogout={handleAdminLogout}
      />
    </>
  );
};

export default LeftBar;
